import sliceCreator from '../../index.jsx';
import {UPDATE_TENANT} from '../../../constants/index.jsx';
const _updateTenantAction = sliceCreator('UPDATE_TENANT', UPDATE_TENANT, 'put');

const { asyncAction: updateTenantAction, reducer, clearData: clearUpdateTenantAction } = _updateTenantAction;

export default reducer;

export {
    updateTenantAction,
    clearUpdateTenantAction
}